import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";

const ChatInput = ({ onSend, loading }) => {
  const [value, setValue] = useState("");

  const submit = () => {
    if (!value.trim()) return;
    onSend(value);
    setValue("");
  };

  return (
    <Box
      sx={{
        p: 1,
        borderTop: "1px solid #e0e0e0",
        display: "flex",
        gap: 1,
        bgcolor: "#fff",
      }}
    >
      <TextField
        fullWidth
        size="small"
        placeholder="Ask about attendance, fees, student details..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        }}
      />
      <Button variant="contained" onClick={submit} disabled={loading}>
        Send
      </Button>
    </Box>
  );
};

export default ChatInput;